import { useSearch } from '@tanstack/react-router';

export const useOwnerId = () => {
    const { OwnerId: ownerId } = useSearch({ strict: false });
    return ownerId;
};

/*
 * By default we are including enterpriseId in all our react-query petitions
 * In some screens we can "shadow" a enterprise's profile, the enterprise id is provided then by the OwnerId param in the URL
 * If this param is present we want to override the default registry to include this param as enterpriseId instead of the default one
 * Currently, our query context does not support a way of extending default params
 * TODO: https://mews.atlassian.net/browse/OPS-21440
 * TODO: Investigate how to improve the swap between ownerId and the current session enterpriseId
 */
export function useOwnerIdQueryPayload() {
    const ownerId = useOwnerId();
    return ownerId ? { enterpriseId: ownerId } : {};
}
